module.exports = __webpack_public_path__ + "static/profile-f52d6a9bbb203679e15b6adbb3e2d861.jpg";